import { Suspense, useCallback } from "react";
import { useState } from "react";
import { quantity } from 'cart-localstorage'
import { useTranslation } from "react-i18next"
import Popup from "../../../components/popup";
import SimpleButton from "../../../components/_input/SimpleButton";
import { InputField } from "../../../components/_input/_input";
import { Price } from "../../../components/__simple/_price";
import { Link } from 'react-router-dom';
import SaleAgreement from "../saleAgreement";
import { SwiperSlide, Swiper } from 'swiper/react';
import { remove, list } from 'cart-localstorage'
import { addToCart } from "../../../_functions/cart";
import axios from "axios";
import config from "../../../configuration/config.json";

export const Coupon = ({ priceOff = 0, onSubmit, onReset }) => {
    const { t: trans, i18n } = useTranslation(["mobileCommon", "mobileHeading", "mobileInputs"]);
    let lang = i18n.language;
    const rotateDir = i18n?.language == 'ar' ? '90deg' : '-90deg';
    const [showPopup, setShowPopup] = useState(false);
    const [applyCoupon, setApplyCoupon] = useState(false);
    const [codeText, setCodeText] = useState('');
    const handleAddCoupon = () => {
        setShowPopup(true);
    };
    const handleClose = () => {
        setShowPopup(false);
    };

    const handleApplyCoupon = () => {
        setShowPopup(false);
        setApplyCoupon(true);
        if (onSubmit)
            onSubmit(codeText);
    };

    const handleResetCoupon = () => {
        setApplyCoupon(false);
        setCodeText('');
        if (onReset)
            onReset();
    };

    const sectionCallback = useCallback(() => {
        return applyCoupon ? (<div className="flex flex-col items-center">
            <div
                className="flex flex-row p-8 justify-between"
            >
                <div className="flex flex-row nice-gap-1rem items-center">
                    <img src="/assets/icons/discount.svg" alt='discount' className="icon-standard" />
                    <span className="text-30 font-bold text-black">{trans("mobileCommon:add_coupon")}</span>
                </div>
            </div>
            <div className="flex flex-row items-center p-8 nice-gap-3rem">
                <div>
                    <span className="text-30 mx-2">{trans("mobileCommon:coupon_discount")}</span>
                    <span className="text-30 text-primary">{priceOff}</span>
                </div>
                <div className="cart-coupon-cancel">
                    <div className="cart-coupon-cancel-code bg-white">
                        <code className="text-30">{codeText}</code>
                        <div
                            className="text-40 nice-pointer px-5 text-gray nice-user-none font-bold"
                            onClick={() => {
                                handleResetCoupon();
                            }}
                        >
                            X
                        </div>
                    </div>
                </div>
            </div>
        </div>) :
            (<div
                className="flex flex-row p-8  nice-pointer nice-gap-10rem"
                onClick={() => {
                    handleAddCoupon()
                }}
            >
                <div className="flex flex-row nice-gap-1rem items-center">
                    <img src="/assets/icons/discount.svg" alt='discount' className="icon-standard" />
                    <span className="text-30 font-bold text-black">{trans("mobileCommon:add_coupon")}</span>
                </div>
                <img src="/assets/icons/arrow-down.svg" style={{ transform: `rotate(${rotateDir})` }} alt='arrow' />
            </div>)
    }, [applyCoupon]);


    return (
        <Suspense>
            {
                sectionCallback()
            }
            <Popup show={showPopup}>
                <div className="w-full h-full flex justify-center items-center">
                    <div className="cart-coupon-container">
                        <h4 className="text-30 font-bold text-center">{trans("mobileHeading:add_coupon")}</h4>
                        <InputField
                            extraClasses={"border-none border-radius-sm  nice-shadow"}
                            value={codeText}
                            onChangeValue={(event) => {
                                setCodeText(event.target.value);
                            }}
                        />
                        <div className="flex flex-row nice-gap-2rem border-t pt-5">

                            <SimpleButton
                                title={trans("mobileInputs:apply")}
                                className=" basis-2/4 nice-style-sm-btn"
                                onClick={() => {
                                    handleApplyCoupon()
                                }}
                            />
                            <div className="border-l text-gray"></div>

                            <SimpleButton
                                title={trans("mobileInputs:cancel")}
                                className=" basis-2/4 nice-style-sm-btn"
                                onClick={() => {
                                    handleClose()
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Popup>
        </Suspense>
    )
};


export const ShippingOff = ({ offer = '', onClick, successMessage }) => {
    return (

        <>

            {

                successMessage &&
                <div className="flex  flex-row  p-8 my-10" >
                    <div className="flex flex-row nice-gap-1rem items-center">
                        <img src="/assets/icons/fast-gray.svg" alt='discount' className="icon-standard" />
                        <span className="text-30 font-bold text-primary">{successMessage}</span>
                    </div>
                </div>
            }



            <div className="flex  flex-row  p-8 my-10"
                onClick={() => {
                    if (onClick) {
                        onClick();
                    }
                }}>
                <div className="flex flex-row nice-gap-1rem items-center">
                    <img src="/assets/icons/fast-gray.svg" alt='discount' className="icon-standard" />
                    <span className="text-30 font-bold text-black">{offer}</span>
                </div>
            </div>
        </>
    )
};



export const CartItem = ({
    id
    , onDelete
    , Account
    , image = null
    , brand = ''
    , title = ''
    , description = ''
    , subTitle = ''
    , cartType
    , count = 0
    , model
    , colorID
    , colorName
    , oldPrice = 0
    , price = 0
    , CategoryCar
    , agreementShow = false
    , agreementLink = "#"
    , salesOrder
    , orderCustInfo
    , orderAuthorized
    , orderTrans
    , showCountBtun = true,
    isShowInfo = false
}) => {
    const { t: trans, i18n } = useTranslation(["mobileCommon","new"]);
    let lang = i18n.language;
    const [itemCount, setItemCount] = useState(count);
    // const [accessories, setAccessories] = useState([{

    //     type: "ooo",
    //     id: "555545",
    //     title: "حماية هيكل السيارة",
    //     subTitle: "الباقة الفضية",
    //     values: [" أمامي 0 ", "جانبي 01 ", "خلفي 02"],
    //     price: "1500",
    //     image: "/assets/icons/addi.svg"
    // }
    //     , {
    //     type: "ooo",
    //     id: "555566645",
    //     title: "حماية هيكل السيارة",
    //     subTitle: "الباقة الفضية",
    //     values: [" أمامي 0 ", "جانبي 01 ", "خلفي 02"],
    //     price: "1500",
    //     image: "/assets/icons/addi.svg"
    // }, {
    //     type: "ooo",
    //     id: "555333545",
    //     title: "حماية هيكل السيارة",
    //     subTitle: "الباقة الفضية",
    //     values: [" أمامي 0 ", "جانبي 01 ", "خلفي 02"],
    //     price: "1500",
    //     image: "/assets/icons/addi.svg"
    // }]);
    const [accessories, setAccessories] = useState([]);
    const [GiftS, setGifts] = useState([]);
    const [showInfo, setShowInfo] = useState(isShowInfo);
    const [CartInfo, setCartInfo] = useState({ id: "", brand: "", modelTypes: "", Color: "", CountGifts: 0, MinPrice: 0, Discount: 0, img: "", CategoryCar: 0 });
    // to deal with item quantity    
    const itemQuantity = (num) => {
        try {

            if (num === -1) {
                if (itemCount == 1)
                    return;
            }

            if (num === -1) {
                setItemCount((value) => value - 1);
            } else if (num === 1) {
                setItemCount((value) => value + 1);
            }

            if (itemCount === 0) {
                setItemCount(1);

            }
            quantity(id, num);

            if (Account)
                Account();
            // complete the code here ..... 
        } catch (error) {
            console.log(error);
        }
    };

    useState(() => {

        if (id && cartType == "car") {
            // CarCartInfo();
            Accessories_Car(id);
            // Gifts_Car(id);
        }
    }, []);
    //SiteAccessories_Cart;
    async function CarCartInfo() {
        await axios.request({
            url: config.controllerUrl + 'api/CartItem/GetCarCartInfo',
            data: { slug: `${id}`, colorId: `${colorID}` }, method: "POST", responseType: "json"
        })
            .then(function (response) {
                var CuurentValue = CartInfo;
                CuurentValue.brand = response.data[0].Brand
                CuurentValue.modelTypes = response.data[0].ModelTypes
                CuurentValue.MinPrice = response.data[0].MinPrice
                CuurentValue.Discount = response.data[0].Discount
                CuurentValue.CountGifts = response.data[0].CountGifts
                CuurentValue.Color = response.data[0].Color
                CuurentValue.year = response.data[0].Model
                CuurentValue.img = response.data[0].img ? "data:image/png;base64," + response.data[0].img : "/assets/images/eparts/default.png";
                CuurentValue.CategoryCar = response.data[0].CategoryCar
                setCartInfo(CuurentValue)
                if (CategoryCar)
                    CategoryCar(CuurentValue.CategoryCar)
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    async function Accessories_Car(ProductsId) {
        await axios.request({
            url: config.controllerUrl + 'api/CartItem/GetCarAccessories',
            data: { productId: `${ProductsId}` }, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data);
                setAccessories(response.data);


            })
            .catch(function (error) {
                console.log(error);
            });
    }
    async function Gifts_Car(ProductsId) {
        await axios.request({
            url: config.controllerUrl + 'api/CartItem/GetCarGifts',
            data: { productId: `${ProductsId}` }, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // console.log(response.data);
                setGifts(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    return (
        <article className="cart-item bg-secondary">
            <div className="flex flex-col  cart-item-radius bg-white">


                {
                    showInfo ? (

                        <SaleAgreement

                            slug={orderTrans?.GUID}
                            brand={brand}
                            image={image}
                            title={title}
                            description={description}
                            subTitle={subTitle}
                            count={count}
                            oldPrice={oldPrice}
                            price={price}
                            salesOrder={salesOrder}
                            orderAuthorized={orderAuthorized}
                            orderCustInfo={orderCustInfo}
                            orderTrans={orderTrans}



                        />
                    ) : (

                        <div className="p-10 nice-container">
                            {
                                onDelete &&
                                <div className="flex flex-row nice-justifiy-end cart-item-remove"
                                    onClick={() => {
                                        if (onDelete)
                                            onDelete(id);
                                    }}
                                >
                                    <img src="/assets/icons/trash.svg" alt='trash' className="icon-standard" />
                                </div>

                            }


                            <div className="cart-item-container">
                                <div className="flex flex-row nice-gap-2rem nice-flex-basis-size-70" >
                                    <div className="cart-item-container-img nice-flex-basis-size-40">
                                        <img src={image ? (image.includes("data:") ? "":"data:image/png;base64," )+ image : '/assets/images/default.png'} alt={title} />
                                    </div>
                                    <div className="flex flex-col justify-center nice-flex-basis-size-60 nice-flex-space-between">
                                        <h4 className="text-30 font-bold mb-5">{brand}</h4>
                                        <span className="text-24 font-bold text-line-clamp text-line-clamp-1">{title + " " +(model ? model :"")}</span>
                                        <span className="text-24 font-bold text-line-clamp text-line-clamp-1">{description}</span>
                                        <span className="text-24 font-bold text-line-clamp text-line-clamp-1">{subTitle}</span>

                                        {

                                            showCountBtun ?
                                                <div className="cart-quantity">
                                                    <div
                                                        className="cart-quantity-btn"
                                                        onClick={() => {
                                                            itemQuantity(+1);
                                                        }}
                                                    >
                                                        +
                                                    </div>
                                                    <span className="text-30 mx-5">{itemCount}</span>
                                                    <div className="cart-quantity-btn"
                                                        onClick={() => {
                                                            itemQuantity(-1);
                                                        }}
                                                    >
                                                        -
                                                    </div>
                                                </div>

                                                :
                                                <div className="flex flex-row nice-gap-1rem">
                                                    <span className="text-30 text-bold text-capitalize">{trans("new:quantity")+":"}</span>
                                                    <span className="text-30">{count}</span>
                                                </div>
                                        }

                                    </div>
                                </div>

                                <div className="flex flex-col  nice-justifiy-end  nice-gap-1rem ">
                                    {(oldPrice > 0) &&

                                        <div className="flex nice-align-item-center nice-gap-1rem">
                                            <span className="line-through text-30 text-bold text-gray">
                                                {oldPrice && <Price price={oldPrice} classNameCurrency={"line-through text-20 text-gray"} />}
                                            </span>
                                            {/* <span className="line-through text-30 text-gray">{" ريال "} </span> */}
                                        </div>

                                    }
                                    <div className="flex nice-align-item-center nice-gap-1rem">
                                        <span className=" text-40 text-bold text-primary">
                                            {price && <Price price={price} classNameCurrency={"text-20 text-primary"} />}
                                        </span>
                                        {/* <span className="text-30 text-primary">{" ريال "} </span> */}
                                    </div>
                                </div>
                            </div>

                        </div>

                    )



                }

                {

                    agreementShow && <Link to={agreementLink} className="flex flex-col items-center  mt-5 p-10"

                        onClick={() => {
                            setShowInfo(!showInfo);
                        }}
                    >


                        {
                            (showInfo == true) ? (

                                <>
                                    <span className="text-20 my-10 text-capitalize">{trans("mobileCommon:agreement_hidden")}</span>
                                    <img src="/assets/icons/arrow-down.svg" className="object-contain rotate-180" />
                                    <img src="/assets/icons/arrow-down.svg" className="object-contain rotate-180" />
                                </>

                            )

                                :
                                (

                                    <>
                                        <span className="text-20 my-10 text-capitalize">{trans("mobileCommon:agreement_show")}</span>
                                        <img src="/assets/icons/arrow-down.svg" className="object-contain" />
                                        <img src="/assets/icons/arrow-down.svg" className="object-contain" />
                                    </>
                                )

                        }
                    </Link>
                }
            </div>
            {
                accessories?.length > 0 &&
                <div className="mt-20 mb-10">
                    <Swiper
                        spaceBetween={15}
                        slidesPerView={2.3}
                        breakpoints={{
                            578: {
                                slidesPerView: 3,
                            },
                        }}
                        autoHeight={true}
                        watchSlidesProgress
                        observeParents
                        observer
                        followFinger
                    >
                        {
                            accessories.map((data, index) => {
                                return (
                                    <SwiperSlide key={index} >
                                       <AccessoryItem
                                            type={data?.type}
                                            id={data?.GUID}
                                            title={lang == "ar" ? data?.DescriptionAr : data?.DescriptionEn}
                                            subTitle={data?.subTitle}
                                            image={data?.img}
                                            values={data?.values}
                                            price={data?.SalesPrice}
                                            categior={data?.ProductGroupID}
                                            productID={data?.ProductID}
                                            onClick={(id, type, addButn) => {

                                                if (Account)
                                                    Account();
                                                return !addButn;
                                            }}
                                        />
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>
                </div>
            }
        </article >
    );
};

export const AccessoryItem = ({
    id,
    type,
    title = '',
    image = null,
    subTitle = '',
    values = [],
    price = 0,
    categior,
    productID,
    onClick,
    added
}) => {
    const get = (id) => list().find((product) => product.id === id)
    const [addButn, setAddButn] = useState(get(id));

    return (
        <article className="cart-accessory nice-gap-2rem bg-white">
            <div
                className="cart-accessory-btn"
                onClick={async () => {
                    if (onClick) {
                        var addValue = await onClick(id, type, addButn);

                        if (addButn) {
                            remove(id);
                        } else {

                            addToCart(
                                {
                                    id: id,
                                    productID: productID,
                                    name: title,
                                    price: price,
                                    image: image,
                                    type: "accessories",
                                    Engine_Groups: categior
                                }
                            )
                        }

                        setAddButn(addValue);
                    }
                }}
            >
                {
                    addButn ?
                        <img src="/assets/icons/trash.svg" alt='-' className="icon-standard" />
                        :
                        <span className="text-50 text-bold">{"+"}</span>
                }

            </div>
            <img src={image ? "data:image/png;base64," + image : '/assets/images/default.png'} alt={title} />
            <div className="flex flex-col">
                <h5 className="text-20 text-bold">{title}</h5>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col">
                        <span className="text-gray text-24">{subTitle}</span>
                        <div className="flex flex-row justify-between">
                            <div className="flex flex-col text-line-clamp text-line-clamp-1">
                                {
                                    values.map((item, index) => {
                                        return <span key={index} className="text-gray text-24">{item}</span>
                                    })
                                }
                            </div>

                        </div>
                    </div>
                    <span className="text-gray font-bold text-30 text-bold self-end"><Price price={price} classNameCurrency={"text-24"} /></span>
                </div>
            </div>

        </article>
    )
};

export const CartBillSummary = ({
    fullTotal = 0,
    total = 0,
    discount = 0,
    fullDiscountTotal = 0,
    onClick
}) => {
    const { t: trans } = useTranslation("mobileCommon");
    return (
        <section className="cart-bill">
            <div className="text-24 mb-20">
                {trans("mobileCommon:cart_agreement_part1")}&nbsp;
                <span className="text-info-light text-24 mx-1">{trans("mobileCommon:cart_agreement_part2")}</span>
                {trans("mobileCommon:cart_agreement_part3")}
            </div>
            <div className="cart-bill-row mb-5">
                <span className="font-bold cart-bill-row-item">{trans("mobileCommon:full_total")}</span>
                <span className="cart-bill-row-item"><Price price={total} /></span>
            </div>
            <div className="cart-bill-row mb-5">
                <span className="font-bold cart-bill-row-item">{trans("mobileCommon:discount_total")}</span>
                <span className="cart-bill-row-item"><Price price={fullDiscountTotal} /></span>
            </div>
            {/* <div className="cart-bill-row ">
                <span className="font-bold cart-bill-row-item">{trans("mobileCommon:discount")}</span>
                <span className="cart-bill-row-item"><Price price={discount} /></span>
            </div> */}
            <div className="cart-bill-line mb-4"></div>
            <div className="cart-bill-row">
                <span className="font-bold text-black">{trans("mobileCommon:total")}</span>
                <div className="flex flex-row mb-5">
                    <span className="text-30 cart-bill-row-item mx-2">{trans("mobileCommon:tax_note")}</span>
                    <span className="text-30 cart-bill-row-item"><Price price={fullTotal} /></span>
                </div>
            </div>


            <div className="flex flex-row nice-gap-2rem my-10">
                <SimpleButton
                    className="text-white bg-primary basis-2/4 order-1"
                    title={trans("complete_buy")}
                    onClick={() => {
                        if (onClick) {
                            onClick();
                        }
                    }}
                />
                <SimpleButton
                    className="text-white bg-black basis-2/4"
                    iconPath={'/assets/icons/apple-pay.png'}
                    onClick={() => {

                    }}
                />
            </div>
        </section>
    )
}
